var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/phone_number/index.js
 ** module id = 1009
 ** module chunks = 0
 **/